import Vue from 'vue'
import Router from 'vue-router'
import Hypnobirthing from './pages/Hypnobirthing.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'hypnobirthing',
      component: Hypnobirthing
    },
    {
      path: '/404',
      component: () => import('./pages/Error404.vue')
    },    
    {
      path: '*',
      redirect: '/404'
    }
  ]
  ,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})
